import React, { Component } from 'react';
import {ServiceUtil, metadataService, userService } from "../_services"
import moment from 'moment/moment';
export class Footer extends Component {
    static displayName = Footer.name;
    constructor(){
        super(); 
        this.state = {licensesUrl: '', privacyUrl:''}
    }
    async componentDidMount() {

        this.setState({
            privacyPolicyUrl: await ServiceUtil.getServiceUrl("PrivacyPolicy"),
            privacyPolicyUrlSpanish: await ServiceUtil.getServiceUrl("PrivacyPolicyEs"),
            licensesUrl: await ServiceUtil.getServiceUrl("Licenses"), 
            licensesUrlSpanish: await ServiceUtil.getServiceUrl("LicensesEs"),
            SMSUrl: await ServiceUtil.getServiceUrl("SMSUrl"),
            SMSUrlSpanish: await ServiceUtil.getServiceUrl("SMSUrlEs"), 
        })
    }
    render() {
        let lang = userService.getUserLanguage().toLowerCase();
        let privacyUrl = lang == "es" ? this.state.privacyPolicyUrlSpanish : this.state.privacyPolicyUrl;
        let licensesUrl = lang === "es" ? this.state.licensesUrlSpanish : this.state.licensesUrl;
        let SMSUrl = lang === "es" ? this.state.SMSUrlSpanish : this.state.SMSUrl;
        return (
            <footer className="footer">
                <div className="footer-text">
                    <a href={licensesUrl} target='_new'>{metadataService.getLabel('Licenses')}</a>
                    &nbsp;|&nbsp;
                    <a href={privacyUrl} target='_new'>{metadataService.getLabel('PrivacyPolicy')}</a> 
                    &nbsp;|&nbsp;
                    <a href={SMSUrl} target='_new'>{metadataService.getLabel('SMSTerms')}</a>                                 
                </div>
                <div className="footer-text small-Text">
                    <div className='p-3' dangerouslySetInnerHTML={{__html : metadataService.getMessage("FooterLenderComplaint")}}></div>
                    <p>
                        {metadataService.getMessage("Copyright",moment().format("YYYY"))}
                    </p>
                </div>
            </footer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer.js